// extracted by mini-css-extract-plugin
module.exports = {"container":"tag_container__f6s3J"};